<template>
  <div class="destination-page">
    <destination-carousel
      v-if="destinations"
      @destinationUpdated="onDestinationSelected"
    ></destination-carousel>
    <div v-if="selectedDestination" class="container">
      <div id="destination-content" class="block text-center p-t">
        <!--        <h1 class="fnt font-deco">{{ selectedDestination.greeting }}</h1>-->
        <h3 class="fnt font-default-light">
          {{ selectedDestination[`description${langCap}`] }}
        </h3>
        <p class="fnt font-default">{{ $t("DESTINATION__INTRO") }}</p>
      </div>

      <div class="block p-b content-narrow">
        <registration-form></registration-form>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
      :title="selectedDestinationTitle"
      width="340px"
    >
      <div v-if="selectedDestination">
        <img class="dialog__img" :src="selectedDestination.imgUrl" alt="" />
      </div>
      <p>
        {{ $t("DESTINATION__CONFIRM_TXT") }}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogClose">{{
          $t("SHARED__CANCEL")
        }}</el-button>
        <el-button type="primary" @click="createPlane">{{
          $t("SHARED__CONFIRM")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import to from "await-to-js"
import { createNamespacedHelpers } from "vuex"
import SmoothScroll from "smooth-scroll/dist/smooth-scroll.polyfills.min.js"

import RegistrationForm from "../components/Form/RegistrationForm"
import DestinationCarousel from "../components/DestinationCarousel"
import { capitalize, getDestinationResource } from "../helpers/string"
import InvitationService from "../services/api/InvitationService"
import UserService from "../services/api/UserService"

const { mapState, mapGetters, mapMutations } = createNamespacedHelpers("app")
const scroll = new SmoothScroll()
const invitationService = new InvitationService()
const userService = new UserService()

export default {
  name: "Destination",
  components: {
    RegistrationForm,
    DestinationCarousel
  },
  data() {
    return {
      invitation: {},
      isFormSubmitted: false,
      dialogVisible: false
    }
  },
  computed: {
    ...mapState(["user", "destinations", "selectedDestination"]),
    ...mapGetters(["utmQs"]),
    selectedDestinationTitle() {
      if (!this.selectedDestination) return ""

      const article =
        this.$i18n.locale === "fr" && this.selectedDestination.article
          ? this.selectedDestination.article.includes("'")
            ? this.selectedDestination.article
            : this.selectedDestination.article + " "
          : ""

      const selectedDestinationTitle =
        this.$i18n.locale === "fr"
          ? article + this.selectedDestination["titleFr"]
          : this.selectedDestination["titleEn"]

      // Capitalize selected destination title
      const selectedDestinationTitleCapitalized =
        selectedDestinationTitle.charAt(0).toUpperCase() +
        selectedDestinationTitle.slice(1)

      return this.$t("DESTINATION__CONFIRM_TITLE").replace(
        "%destination%",
        selectedDestinationTitleCapitalized
      )
    },
    langCap() {
      return capitalize(this.$i18n.locale)
    }
  },
  methods: {
    ...mapMutations(["setSelectedDestination"]),
    onDestinationSelected() {
      if (!this.invitation.id) {
        this.$nextTick(() => {
          scroll.animateScroll(
            document.querySelector("#destination-content"),
            null,
            {
              offset: 0,
              speed: 700,
              updateURL: false,
              popstate: false
            }
          )
        })
      } else {
        this.dialogVisible = true
      }
    },
    async createPlane() {
      if (this.isFormSubmitted) {
        return
      }
      this.isFormSubmitted = true
      let err, user
      ;[err, user] = await to(
        userService.create({
          destination: getDestinationResource(this.selectedDestination.id),
          firstname: this.invitation.recipientFirstname,
          lastname: this.invitation.recipientLastname,
          email: this.invitation.recipientEmail,
          zip: this.invitation.zip,
          isSubscribedToContestMessages: true
        })
      )

      if (err) {
        this.$router.replace({ name: "error" })
      } else {
        this.$gtag.event("PlaneFromInvitation")
        this.$router.replace({
          name: "status",
          query: { t: user.token, u: user.id }
        })
      }
    },
    handleDialogClose() {
      this.dialogVisible = false
    }
  },
  async created() {
    this.setSelectedDestination(null)
    const invitationId = this.$route.query.i
    const token = this.$route.query.t
    if (invitationId && token) {
      let invErr, invRes
      ;[invErr, invRes] = await to(
        invitationService.getInvitation(invitationId, token)
      )

      if (invErr) {
        this.$router.replace({ name: "error" })
      }

      this.invitation = invRes

      // User has plane
      if (this.invitation.token && this.invitation.contestUserId) {
        this.$router.replace({
          name: "status",
          query: { t: this.invitation.token, u: this.invitation.contestUserId }
        })
      }
    }
  },
  mounted() {
    window.setTimeout(() => {
      scroll.animateScroll(document.querySelector("#app"), null, {
        offset: 0,
        speed: 700,
        updateURL: false,
        popstate: false
      })
    }, 200)
  }
}
</script>

<style scoped></style>
